import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';
export class DeclarationExport {
    static jsonMap = {
        campagne: { key: 'campagne', optional: true, default: '' },
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        ville: { key: 'ville', optional: true, default: '' },
        numeroDossier: { key: 'numeroDossier', optional: true, default: '' },
        numeroCVI: { key: 'numeroCVI', optional: true, default: '' },
        dateMvt: { key: 'dateMvt', converter: new DateConverter(), optional: true },
        logement: { key: 'logement', optional: true, default: '' },
        numero: { key: 'numero', optional: true, default: '' },
        cahierDesCharges: { key: 'cahierDesCharges', optional: true, default: '' },
        produit: { key: 'produit', optional: true, default: '' },
        couleur: { key: 'couleur', optional: true, default: '' },
        mouvement: { key: 'mouvement', optional: true, default: '' },
        destination: { key: 'destination', optional: true, default: '' },
        cepage: { key: 'cepage', optional: true, default: '' },
        volume: { key: 'volume', optional: true },
        idIntervenant: { key: 'idIntervenant', optional: true },
        siteEntreposage: { key: 'siteEntreposage', optional: true, default: '' },
        evenement: { key: 'evenement', optional: true, default: '' },
        dateEvenement: { key: 'dateEvenement', converter: new DateConverter(), optional: true },

        // Tirage
        numTirage: { key: 'numTirage', optional: true, default: '' },
        typeVinTirage: { key: 'typeVinTirage', optional: true, default: '' },
        volumeVinBase: { key: 'volumeVinBase', optional: true },
        raisonSocialePrestataire: { key: 'raisonSocialePrestataire', optional: true, default: '' },
        siretPrestataire: { key: 'siretPrestataire', optional: true, default: '' },

        // Transaction
        typeTransaction: { key: 'typeTransaction', optional: true, default: '' },
        raisonSocialeAcheteurTransaction: { key: 'raisonSocialeAcheteurTransaction', optional: true, default: '' },
        siretAcheteurTransaction: { key: 'siretAcheteurTransaction', optional: true, default: '' },
        idIntervenantAcheteurTransaction: { key: 'idIntervenantAcheteurTransaction', optional: true },
        numContrat: { key: 'numContrat', optional: true, default: '' },

        // Changement de produit
        typeLotChangementProduit: { key: 'typeLotChangementProduit', optional: true, default: '' },
        cdcOrigineChangementProduit: { key: 'cdcOrigineChangementProduit', optional: true, default: '' },
        produitOrigineChangementProduit: { key: 'produitOrigineChangementProduit', optional: true, default: '' },

        // DREV AOC
        mentionValorisante: { key: 'mentionValorisante', optional: true, default: '' },
        surfaceLot: { key: 'surfaceLot', optional: true },
        volumeVinRevendique: { key: 'volumeVinRevendique', optional: true },
        vciN1Revendique: { key: 'vciN1Revendique', optional: true },
        vciN1raffraichi: { key: 'vciN1raffraichi', optional: true },
        vciN1complement: { key: 'vciN1complement', optional: true },
        vciN1substitution: { key: 'vciN1substitution', optional: true },
        vciDetruit: { key: 'vciDetruit', optional: true },
        vciNouveau: { key: 'vciNouveau', optional: true },
        stockVci: { key: 'stockVci', optional: true },
        typeRevendication: { key: 'typeRevendication', optional: true, default: '' },
        labelsEnvironnementaux: { key: 'labelsEnvironnementaux', optional: true, default: '' }
    };

    campagne: string;
    raisonSociale: string;
    adresse: string;
    codePostal: string;
    ville: string;
    numeroDossier: string;
    numeroCVI: string;
    dateMvt: moment.Moment;
    logement: string;
    numero: string;
    cahierDesCharges: string;
    produit: string;
    couleur: string;
    mouvement: string;
    destination: string;
    cepage: string;
    volume: number;
    idIntervenant: number;

    siteEntreposage: string;
    evenement: string;
    dateEvenement: moment.Moment;

    // Tirage
    numTirage: string;
    typeVinTirage: string;
    volumeVinBase: number;
    raisonSocialePrestataire: string;
    siretPrestataire: string;

    // Transaction
    typeTransaction: string;
    raisonSocialeAcheteurTransaction: string;
    siretAcheteurTransaction: string;
    idIntervenantAcheteurTransaction: number;
    numContrat: string;

    // Changement de produit
    typeLotChangementProduit: string;
    cdcOrigineChangementProduit: string;
    produitOrigineChangementProduit: string;

    // DREV AOC
    mentionValorisante: string;
    surfaceLot: number;
    volumeVinRevendique: number;
    vciN1Revendique: number;
    vciN1raffraichi: number;
    vciN1complement: number;
    vciN1substitution: number;
    vciDetruit: number;
    vciNouveau: number;
    stockVci: number;
    typeRevendication: string;
    labelsEnvironnementaux: string;
}
